import { render, staticRenderFns } from "./JobTaskSection.vue?vue&type=template&id=37e5cbde&scoped=true&"
import script from "./JobTaskSection.vue?vue&type=script&lang=js&"
export * from "./JobTaskSection.vue?vue&type=script&lang=js&"
import style0 from "./JobTaskSection.vue?vue&type=style&index=0&id=37e5cbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5cbde",
  null
  
)

export default component.exports